import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DesktopOnboarding from "./DesktopOnboarding";

const IntroPage = () => {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
   
      const timeout = setTimeout(() => {
        navigate("/loading");
      }, 1500);
      return () => clearTimeout(timeout);
    
  }, []);

  if (isDesktop) {
    return <DesktopOnboarding />;
  }

  return (
    <div className="h-screen w-screen bg-black flex justify-center items-center">
      <div className="h-[95vh] w-[300px] overflow-hidden">
        <img
          src="/Opening.png"
          alt="intro"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default IntroPage;